// Salesforce Field Import functionality
// This handles the selection and import of Salesforce fields

window.updateSalesforceFieldSelection = function() {
  const checkboxes = document.querySelectorAll('.sf-field-checkbox:checked');
  const selectedFields = [];

  checkboxes.forEach(cb => {
    selectedFields.push({
      name: cb.dataset.fieldName,
      label: cb.dataset.fieldLabel,
      type: cb.dataset.fieldType,
      custom: cb.dataset.fieldCustom === 'true'
    });
  });

  const jsonField = document.getElementById('selected_fields_json');
  if (jsonField) jsonField.value = JSON.stringify(selectedFields);

  const countDisplay = document.getElementById('selected_count_display');
  if (countDisplay) countDisplay.textContent = selectedFields.length + ' selected';

  const importBtn = document.getElementById('import_sf_fields_btn');
  if (importBtn) {
    importBtn.disabled = selectedFields.length === 0;
    importBtn.textContent = selectedFields.length === 0 ?
      'Import Selected Fields' :
      `Import ${selectedFields.length} Field${selectedFields.length === 1 ? '' : 's'}`;
  }

  // Update select all checkbox state
  const allCheckboxes = document.querySelectorAll('.sf-field-checkbox');
  const selectAll = document.getElementById('select_all_sf_fields');
  if (selectAll) {
    selectAll.checked = checkboxes.length === allCheckboxes.length && allCheckboxes.length > 0;
    selectAll.indeterminate = checkboxes.length > 0 && checkboxes.length < allCheckboxes.length;
  }
};

window.toggleAllSalesforceFields = function(selectAllCheckbox) {
  const checkboxes = document.querySelectorAll('.sf-field-checkbox');
  checkboxes.forEach(cb => {
    cb.checked = selectAllCheckbox.checked;
  });
  window.updateSalesforceFieldSelection();
};

// Use event delegation for dynamically loaded Turbo Frame content
document.addEventListener('click', function(event) {
  // Handle individual field checkbox clicks
  if (event.target.classList.contains('sf-field-checkbox')) {
    window.updateSalesforceFieldSelection();
  }

  // Handle select all checkbox clicks
  if (event.target.id === 'select_all_sf_fields') {
    window.toggleAllSalesforceFields(event.target);
  }
});
